import { useInfiniteQuery } from "@tanstack/react-query";
import useOrganizationId from "customHooks/useOrganizationId";
import { callApiV2 } from "util/apiCaller";

export const RQ_GET_CUSTOMERS = "RQ_GET_CUSTOMERS";

const LIST_PAGE_SIZE = 100;

const fetchCustomers = async ({
  orgId,
  filters,
  pageParam,
  dataSourceEs,
  getAll,
  shouldUseCampaignDomain,
  isCampaignPage,
}) => {
  const res = await callApiV2({
    endpoint: `v1/organizations/${orgId}/customers/list-new/?offset=${pageParam}&limit=${LIST_PAGE_SIZE}${
      dataSourceEs ? "&data_source=es" : ""
    }${getAll ? "&all=true" : ""}${dataSourceEs ? "&data_source=es" : ""}${
      isCampaignPage && shouldUseCampaignDomain
        ? "&is_via_campaign_page=true"
        : ""
    }`,
    method: "post",
    body: filters,
    isErrorSuppressed: true,
    shouldUseCampaignDomain,
    timeout: null,
  });

  if (res?.results?.result) {
    return { list: res.results.data, count: res.count };
  }

  throw new Error(res.message);
};

const useFetchCustomers = ({
  options = {},
  params = {
    getAll: false,
    filters: [],
    dataSourceEs: false,
    isCampaignPage: false,
  },
  select = (data) => data,
} = {}) => {
  const orgId = useOrganizationId();

  const isCampaignPage = window.location.pathname.includes("/notification/");

  const shouldUseCampaignDomain =
    orgId &&
    [
      "454407b2-41bb-45fc-b130-6c2bf146b783",
      "38a697d8-c2ce-4e94-812b-7ec688e27100",
      "95bca1d3-4565-4ca8-93ff-dabccd505fde", // paisabazaar
      "2bebc2a4-a54e-4b31-99ce-e1dbc75be18c", // paisabazaar
    ].includes(orgId);

  return useInfiniteQuery({
    queryKey: [RQ_GET_CUSTOMERS, orgId, params],
    queryFn: ({ pageParam = 0 }) =>
      fetchCustomers({
        ...params,
        pageParam,
        orgId,
        shouldUseCampaignDomain,
        isCampaignPage,
      }),
    getNextPageParam: (_, pages) => pages.length * LIST_PAGE_SIZE,
    select,
    enabled:
      options.enabled === undefined ? !!orgId : !!orgId && !!options.enabled,
    ...options,
  });
};

export default useFetchCustomers;
